import * as NameSpace from 'src/store/NameSpace'
import { ParseService } from '../../Services/parse'
// import { FlexTable } from 'src/components/shared/flexTables'
import { pick } from 'lodash'
import { simulateClick } from 'src/components/shared/helper/simulateClick'
import {MERCHANT_PORTAL_GUIDE_URL} from '../../constants/Constants'
// import { pendingApprovalMock } from 'src/components/pending-approval/mock'
// import { pendingApprovalSchema } from 'src/components/pending-approval/schema'

const state = {
  [NameSpace.STATE_PENDING_APPROVALS]: {
    fix: {
      headers: [],
      data: []
    },
    scrollablePending: {
      headers: [],
      data: []
    },
    scrollablePast: {
      headers: [],
      data: []
    },
    error: null
  },
  [NameSpace.SELECTED_AGG_CELL]: {},
  [NameSpace.AGG_INPUT_FILTER_DATA]: {},
  [NameSpace.DOWNLOAD_ERROR]: null,
  [NameSpace.CONFIRMATION_MAIL_RESPONSE]: null,
  [NameSpace.NAV_BAR_COLLAPSE]: false
}

const getters = {
  [NameSpace.GET_NAV_BAR_COLLAPSE]: state => {
    return state[NameSpace.NAV_BAR_COLLAPSE]
  },
  [NameSpace.GET_AGGREGATED_FIX_TABLE]: state => {
    return state[NameSpace.STATE_PENDING_APPROVALS].fix
  },
  [NameSpace.GET_PENDING_AGGREGATED_SCROLLABLE_TABLE]: state => {
    return state[NameSpace.STATE_PENDING_APPROVALS].scrollablePending
  },
  [NameSpace.GET_PAST_AGGREGATED_SCROLLABLE_TABLE]: state => {
    return state[NameSpace.STATE_PENDING_APPROVALS].scrollablePast
  },
  [NameSpace.GET_SELECTED_AGG_DATA]: state => {
    return state[NameSpace.SELECTED_AGG_CELL]
  },
  [NameSpace.GET_AGG_INPUT_FILTER_DATA]: state => {
    return state[NameSpace.AGG_INPUT_FILTER_DATA]
  },
  [NameSpace.GET_AGG_INPUT_FILTER_NAME]: state => {
    let stateObject = state[NameSpace.AGG_INPUT_FILTER_DATA]
    let result = {}
    for (let object in stateObject) {
      let pickData = pick(stateObject[object], ['name'])
      result[object] = pickData
    }
    return stateObject
  },
  [NameSpace.GET_AGG_INPUT_FILTER_ID]: state => {
    let clonedObject = state[NameSpace.AGG_INPUT_FILTER_DATA]
    let result = {}
    for (let object in clonedObject) {
      let pickData = pick(clonedObject[object], ['id'])
      result[object] = pickData
    }
    return result
  },
  [NameSpace.GET_DOWNLOAD_ERROR]: state => {
    return state[NameSpace.DOWNLOAD_ERROR]
  },
  [NameSpace.GETTER_CONFIRMATION_MAIL_RESPONSE]: state => {
    return state[NameSpace.CONFIRMATION_MAIL_RESPONSE]
  }
}

const mutations = {
  [NameSpace.MUTATE_NAV_BAR_COLLAPSE]: (state, payload) => {
    state[NameSpace.NAV_BAR_COLLAPSE] = payload
  },
  [NameSpace.MUTATE_PENDING_APPROVALS]: (state, payload) => {
    state[NameSpace.STATE_PENDING_APPROVALS] = payload
  },
  [NameSpace.MUTATE_SELECTED_AGG_DATA]: (state, payload) => {
    state[NameSpace.SELECTED_AGG_CELL] = payload
  },
  [NameSpace.MUTATE_AGG_INPUT_FILTER_DATA]: (state, payload) => {
    state[NameSpace.AGG_INPUT_FILTER_DATA] = payload
  },
  [NameSpace.MUTATE_DOWNLOAD_ERROR]: (state, payload) => {
    state[NameSpace.DOWNLOAD_ERROR] = payload
  },
  [NameSpace.MUTATE_CONFIRMATION_MAIL_RESPONSE]: (state, payload) => {
    state[NameSpace.CONFIRMATION_MAIL_RESPONSE] = payload
  }
}

const actions = {
  [NameSpace.ACTION_NAV_BAR_COLLAPSE]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_NAV_BAR_COLLAPSE, payload)
  },
  [NameSpace.RESET_PENDING_APPROVALS]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_PENDING_APPROVALS, {
      fix: {
        headers: [],
        data: []
      },
      scrollablePending: {
        headers: [],
        data: []
      },
      scrollablePast: {
        headers: [],
        data: []
      },
      error: null
    })
  },
  [NameSpace.ACTION_PENDING_APPROVALS]: ({ commit }, payload) => {
    ParseService.getAggregatedOffers(payload)
      .then(aggregatedOffers => {
        let headerPart = aggregatedOffers.header.colours
        let dataPart = aggregatedOffers.data
        let rowData = []
        // For fixed table
        for (let key in headerPart) {
          let headerField = {}
          let columnArray = []
          if (key !== 'pending_offers' && key !== 'past_offers') {
            headerField.data = {value: headerPart[key].name}
            columnArray.push(headerField)
          }
          for (let dataKey in dataPart) {
            if (key !== 'pending_offers' && key !== 'past_offers') {
              let dataField = {}
              let v = dataPart[dataKey][key].offerCount + '(' + dataPart[dataKey][key].itemCount + ')'
              let existProperty = dataPart[dataKey][key]
              existProperty.clickable = dataPart[dataKey][key].offerCount > 0
              dataField.data = {value: v, others: existProperty}
              columnArray.push(dataField)
            }
          }
          rowData.push(columnArray)
        }
        // For scrollable table
        let scrollableHeaderPart = aggregatedOffers.header.colours.pending_offers.contains
        let pendingScrollbaleRowArray = []
        let pastScrollbaleRowArray = []
        for (let key in scrollableHeaderPart) {
          // Pending
          let headerField = {}
          let pendingColumnArray = []
          headerField.data = {value: scrollableHeaderPart[key].name}
          pendingColumnArray.push(headerField)
          // Past
          let pastHeaderField = {}
          let pastColumnArray = []
          pastHeaderField.data = {value: scrollableHeaderPart[key].name}
          pastColumnArray.push(pastHeaderField)
          for (let dataKey in dataPart) {
            let pendingDataField = {}
            let pastDataField = {}
            let pendingObject = dataPart[dataKey]['pending_offers']
            pendingDataField.data = {value: pendingObject[key]}
            pendingColumnArray.push(pendingDataField)

            let pastObject = dataPart[dataKey]['past_offers']
            pastDataField.data = {value: pastObject[key]}
            pastColumnArray.push(pastDataField)
          }
          pendingScrollbaleRowArray.push(pendingColumnArray)
          pastScrollbaleRowArray.push(pastColumnArray)
        }
        // console.log(pendingScrollbaleRowArray, pastScrollbaleRowArray)
        // console.log('---AGGREGATED OFFERS:---', JSON.stringify(aggregatedOffers))
        // let pendingApprovalSchemaSet = aggregatedOffers.header.colours
        // pendingApprovalSchemaSet = omit(pendingApprovalSchemaSet, ['past_offers', 'pending_offers'])
        // let scrollablePendingJson = aggregatedOffers.header.colours.pending_offers.contains
        // for (var i in scrollablePendingJson) {
        //   pendingApprovalSchemaSet = merge(pendingApprovalSchemaSet, {[i]: scrollablePendingJson[i]})
        // }
        // let tableInstance = new FlexTable(pendingApprovalSchemaSet, aggregatedOffers.data, 1)
        // let fixedTableHeaders = tableInstance.getHeadersForFixedTable(pendingApprovalSchemaSet, 'landingPage')
        // fixedTableHeaders.unshift({value: 'CLASSIFIED BY TOOL'})
        // let linkableHeaders = tableInstance.getLinkableHeaders(pendingApprovalSchemaSet, 'makeLink')
        // let fixedTableData = tableInstance.getCellDataAsObject(linkableHeaders, aggregatedOffers.data, 'makeLink', 'landing', -1)
        // // console.log(aggregatedOffers.data)
        // let scrollableTableHeaders = tableInstance.getHeadersForScrollableTable(pendingApprovalSchemaSet, linkableHeaders)
        // let scrollableMapHeaders = tableInstance.getMapHeaders(pendingApprovalSchemaSet, linkableHeaders)
        // // pending approvals
        // let pendingObject = {}
        // for (var pendingKey in aggregatedOffers.data) {
        //   let eachObject = {}
        //   let otherJson = aggregatedOffers.data[pendingKey].pending_offers
        //   for (let k in otherJson) {
        //     eachObject[k] = otherJson[k]
        //   }
        //   pendingObject[pendingKey] = eachObject
        // }
        // // past approvals
        // let pastObject = {}
        // for (var pastKey in aggregatedOffers.data) {
        //   let eachObject = {}
        //   let otherJson = aggregatedOffers.data[pastKey].past_offers
        //   for (let k in otherJson) {
        //     eachObject[k] = otherJson[k]
        //   }
        //   pastObject[pastKey] = eachObject
        // }
        // let scrollableTableDataForPending = tableInstance.getTableDataAsObjectArray(scrollableMapHeaders, pendingObject, false)
        // let scrollableTableDataForPast = tableInstance.getTableDataAsObjectArray(scrollableMapHeaders, pastObject, false)
        // commit(NameSpace.MUTATE_PENDING_APPROVALS, {
        //   fix: {
        //     headers: fixedTableHeaders,
        //     data: fixedTableData
        //   },
        //   scrollablePending: {
        //     headers: scrollableTableHeaders,
        //     data: scrollableTableDataForPending
        //   },
        //   scrollablePast: {
        //     headers: scrollableTableHeaders,
        //     data: scrollableTableDataForPast
        //   },
        //   error: null
        // })
        commit(NameSpace.MUTATE_PENDING_APPROVALS, {
          fix: rowData,
          scrollablePending: pendingScrollbaleRowArray,
          scrollablePast: pastScrollbaleRowArray,
          error: null
        })
      })
      .catch(error => {
        console.log(error)
        // commit(NameSpace.MUTATE_OFFER_NAMES, {value: [], error: error})
      })
  },
  [NameSpace.ACTION_SELECTED_AGG_DATA]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_SELECTED_AGG_DATA, payload)
  },
  [NameSpace.SET_AGG_INPUT_FILTER_DATA]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_AGG_INPUT_FILTER_DATA, payload)
  },
  [NameSpace.ACTION_DOWNLOAD_ALL_DETAILS]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null)
    ParseService.downloadMerchantAllDetails(payload)
      .then(result => {
        console.log(result)
        simulateClick(result.url)
      })
      .catch(error => {
        console.log('oops! Error in downloading template', error)
        commit(NameSpace.MUTATE_DOWNLOAD_ERROR, error)
      })
  },
  [NameSpace.ACTION_DOWNLOAD_PORTAL_GUIDE]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null)
    simulateClick(MERCHANT_PORTAL_GUIDE_URL)
  },
  [NameSpace.ACTION_DOWNLOAD_MANUFACTURER_INFO]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null)
    ParseService.downloadManufacturerInfo(payload)
      .then(result => {
        console.log(result)
        simulateClick(result.url)
      })
      .catch(error => {
        console.log('oops! Error in downloading template', error)
        commit(NameSpace.MUTATE_DOWNLOAD_ERROR, error)
      })
  },
  //  change
  [NameSpace.ACTION_DOWNLOAD_NEGATIVEMARGIN_ITEMS]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null)
    ParseService.downloadNegativeMarginItems(payload)
      .then(result => {
        console.log(result)
        simulateClick(result.url)
      })
      .catch(error => {
        console.log('oops! Error in downloading template', error)
        commit(NameSpace.MUTATE_DOWNLOAD_ERROR, error)
      })
  },
  //  change
  [NameSpace.ACTION_DOWNLOAD_MERCHANT_TEMPLATE]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null)
    ParseService.downloadTemplateMerchant({})
      .then(result => {
        simulateClick(result.url)
      })
      .catch(error => {
        commit(NameSpace.MUTATE_DOWNLOAD_ERROR, error)
      })
  },
  [NameSpace.ACTION_DOWNLOAD_DAX]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null)
    ParseService.downloadDax(payload)
      .then(result => {
        simulateClick(result.url)
      })
      .catch(error => {
        commit(NameSpace.MUTATE_DOWNLOAD_ERROR, error)
      })
  },
  [NameSpace.ACTION_SEND_CONFIRMATION_MAIL]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_CONFIRMATION_MAIL_RESPONSE, null)
    ParseService.sendFinalConfirmationMails(payload)
      .then(result => {
        commit(NameSpace.MUTATE_CONFIRMATION_MAIL_RESPONSE, result)
      })
      .catch(error => {
        console.log('oops! Error in send mail', error)
        commit(NameSpace.MUTATE_CONFIRMATION_MAIL_RESPONSE, error)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/pendingApprovals.js